// @flow
export const OPTIONS_THEME_API = {
  active: '',
  disabledOption: '',
  firstOptionHighlighted: '',
  hasNoSelectedOptionCheckmark: '',
  hasSearch: '',
  highlightedOption: '',
  isOpen: '',
  openUpward: '',
  option: '',
  options: '',
  search: '',
  selectedOption: '',
  ul: ''
};
